import React, { useState } from "react";
import "./Contact_Us.css";
import Common_Banner from "../common_components/common_banner/Common_Banner";
import {
  faCircleXmark,
  faEnvelope,
  faLocationDot,
  faMapLocationDot,
  faMaximize,
  faMinimize,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import classNames from "classnames";
import Submit_Btn from "../common_components/common_btn/submit_btn/Submit_Btn";
import Successfull_Lottie from "../animation/Successfull_Lottie/Successfull_Lottie";

const Contact_Us = () => {
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const contactData = [
    {
      text: "Pune, Maharashtra",
      icon: faLocationDot,
    },
    {
      text: "9767297324 / 9665441753",
      icon: faPhone,
    },
    {
      text: "techinteriorsanddesigners@gmail.com",
      icon: faEnvelope,
    },
  ];

  const [showMap, setShowMap] = useState(false);

  console.log("showMap", showMap);

  const toggleMap = () => {
    console.log("showMap", showMap);
    setShowMap(!showMap);
  };

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const socialIcons = [
    // { icon: faLinkedinIn, link: "https://www.linkedin.com" },
    { icon: faFacebookF, link: "https://www.facebook.com/people/Tech-Interiors-and-Designers/61581722197336/" },
    // { icon: faXTwitter, link: "https://www.twitter.com" },
    { icon: faInstagram, link: "https://www.instagram.com/techinteriors_designers/" },
  ];

  const [formSubmitted, setFormSubmitted] = useState(false);

  // EmailJS form submission function
  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Contact No</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.contact_no}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">City</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.city}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const payload = {
        email: "techinteriorsanddesigners@gmail.com",
        subject: "demo",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setFormSubmitted(true);
        setTimeout(() => {
          navigate("/");
          setFormSubmitted(false);
        }, 3000);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  return (
    <section className="Contact_Us">
      <Common_Banner
        imgSrc={"/assets/images/contact_us/contact_banner.png"}
        title_text={"Contact Us"}
      />

      <div className="container">
        <section className="ContactUsForm">
          <div className={`inner_contact_form ${showMap ? "hidden" : ""}`}>
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12   me-0 p-0 ms-0">
                <div className="main_form_div">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="input_group">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Full Name*"
                        {...register("name", {
                          required: "Name is required",
                        })}
                        className={classNames("", {
                          "is-valid": getValues("name"),
                        })}
                      />
                      {errors?.name && (
                        <span className="invalid-feedback d-block">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group className="input_group">
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Enter Email*"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            message: "Invalid email address",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.email,
                          "is-valid": getValues("email"),
                        })}
                      />
                      {errors?.email && (
                        <span className="invalid-feedback d-block">
                          {errors.email.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group className="input_group">
                      <Controller
                        country="in"
                        name="contact_no"
                        control={control}
                        rules={{
                          required: "contact_no is required",
                          minLength: {
                            value: 10,
                            message: "Number should be at least 10 characters",
                          },
                        }}
                        render={({ field }) => (
                          <PhoneInput
                            country={"in"}
                            {...field}
                            className={classNames("", {
                              "is-invalid": errors?.contact_no,
                              "is-valid": getValues("contact_no"),
                            })}
                            onChange={(value) => field.onChange(value)}
                            type="text"
                            placeholder="Enter Contact Number*"
                            maxLength={10}
                          />
                        )}
                      />
                      {errors?.contact_no && (
                        <span className="invalid-feedback d-block">
                          {errors.contact_no.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group
                      className="input_group"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Control
                        type="text"
                        name="city"
                        placeholder="Enter City"
                        {...register("city", {
                          required: "Name is required",
                        })}
                        className={classNames("", {
                          "is-valid": getValues("city"),
                        })}
                      />
                      {errors?.name && (
                        <span className="invalid-feedback d-block">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group className="input_group">
                      <Form.Control
                        as={"textarea"}
                        type="text"
                        name="message"
                        placeholder="Write your message here"
                        {...register("message", {
                          required: "Message is required",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.message,
                          "is-valid": getValues("message"),
                        })}
                      />
                      {errors?.message && (
                        <span className="invalid-feedback d-block">
                          {errors.message.message}
                        </span>
                      )}
                    </Form.Group>

                    {!formSubmitted ? (
                      <div className="send_btn_div">
                        <Submit_Btn
                          btn_name="Submit"
                          type="submit"
                        // onClick={() => {
                        //   setFormSubmitted(true);

                        //   setTimeout(() => {
                        //     navigate("/");
                        //     setFormSubmitted(false);
                        //   }, 3000);
                        // }}
                        />
                      </div>
                    ) : (
                      <div className="success_div">
                        <Successfull_Lottie successText="Message Sent Successfully" />
                      </div>
                    )}
                  </Form>
                </div>
              </div>

              <div className="col-lg-4 col-md-5 col-sm-12   me-0 p-0 ms-0">
                <div className="contact_us_info_main_div">
                  <p className="type_text">Office</p>

                  {contactData?.map((item, index) => {
                    const isPhone = item.icon === faPhone;
                    const isEmail = item.icon === faEnvelope;

                    return (
                      <div className="contact_us_info_div" key={index}>
                        <div className="icon_holder">
                          <FontAwesomeIcon icon={item?.icon} className="icon" />
                        </div>
                        <div className="text_holder">
                          {isPhone ? (
                            // If it's phone -> clickable numbers
                            <div>
                              <a href="tel:9767297324" className="text">
                                9767297324
                              </a>
                              <span className="text">{" / "}</span>
                              <a href="tel:9665441753" className="text">
                                9665441753
                              </a>
                            </div>
                          ) : isEmail ? (
                            <a
                              href={`https://mail.google.com/mail/?view=cm&fs=1&to=${item.text}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text"
                            >
                              {item.text}
                            </a>
                          ) : (

                            <p
                              className={`text ${item?.underline ? "find_us" : ""
                                }`}
                              onClick={item?.underline ? toggleMap : undefined}
                            >
                              {item.text}
                            </p>
                          )}
                        </div>
                      </div>
                    );
                  })}

                  <div className="contact_us_info_div find_us_div">
                    <div className="icon_holder">
                      <FontAwesomeIcon
                        icon={faMapLocationDot}
                        className="icon"
                      />
                    </div>
                    <div className="text_holder">
                      <p className={`text find_us`} onClick={toggleMap}>
                        Find Us on Map
                      </p>
                    </div>
                  </div>

                  <div className="social_div_row">
                    {socialIcons.map((item, index) => (
                      <div
                        className="icon_holder"
                        key={index}
                        onClick={() =>
                          window.open(
                            item.link,
                            "_blank",
                            "noopener,noreferrer"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="social_icon"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`map ${!showMap ? "hidden" : "show"} `}>
            <iframe
              className="gmap_iframe"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
            ></iframe>
            <div className="close">
              <div className="map-icons">
                <FontAwesomeIcon
                  icon={faCircleXmark}
                  className="close-icon"
                  onClick={toggleMap}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Contact_Us;
